module.exports = __webpack_public_path__ + "static/media/unaro-full-icon.acbbd39e.svg";